<template>
  <div id="app" class="vue-plugin-wrapper" :style="{ '--main-color': mainColor }">

    <div class="d-block d-md-block d-lg-block">
      <div class="row mx-4 mb-5  d-none d-md-flex d-lg-flex twoqbsAllFilters">
        <div class="col-md-2 col-lg-2">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">

            <div class="twoqbsTypeFilter">
              <button @click="showTypeFilters = !showTypeFilters" class="btn btn-outline-dark twoqbsStageButton">
                Rodzaj lokalu
              </button>

              <div v-show="showTypeFilters" class="twoqbsTypeCheckboxList text-start text-nowrap">
                <div v-for="(item, index) in typeOf" :key="index">
                  <input @change="filterdTable(price, rooms, area, isAvailable, checkedTypes)" type="checkbox"
                    :id="item" v-model="checkedTypes" :value="item" />
                  <label :for="item">
                    <span>&nbsp;</span>{{ item }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-2 range-slider">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">
            <span @click="sortBy('price')" class="btn btn-outline-dark twoqbsStageButton">Cena <span
                v-if="sortKey === 'price'">
                <span v-if="sortAsc"> ↑</span>
                <span v-else> ↓</span>
              </span><span v-else> ↑↓</span></span>
          </div>
          <vue-range-slider ref="slider" width="100%" v-model="price"
            @input="filterdTable(price, rooms, area, isAvailable, checkedTypes)" :min="minPrice" :max="maxPrice"
            :formatter="numberWithSpaces" :step="10000">

          </vue-range-slider>
        </div>
        <div class="col-md-12 col-lg-2 range-slider">
          <!-- <div class="mb-4" style="text-align: left">Cena</div>
          <vue-range-slider
            ref="slider"
            width="100%"
            v-model="price"
            @input="filterdTable(price, area, isAvailable)"
            :min="minPrice"
            :max="maxPrice"
            :step="10000"
          >
          </vue-range-slider> -->
          <!-- </div> -->
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">
            <span @click="sortBy('rooms')" class="btn btn-outline-dark twoqbsStageButton">Pokoje<span
                v-if="sortKey === 'rooms'">
                <span v-if="sortAsc"> ↑</span>
                <span v-else> ↓</span>
              </span><span v-else> ↑↓</span></span>
          </div>
          <vue-range-slider ref="slider" width="100%" v-model="rooms"
            @input="filterdTable(price, rooms, area, isAvailable, checkedTypes)" :min="minRooms" :max="maxRooms"
            :step="1">
          </vue-range-slider>
        </div>
        <div class="col-md-12 col-lg-2 range-slider">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">
            <span @click="sortBy('area')" class="btn btn-outline-dark twoqbsStageButton">Powierzchnia<span
                v-if="sortKey === 'area'">
                <span v-if="sortAsc"> ↑</span>
                <span v-else> ↓</span>
              </span><span v-else> ↑↓</span></span>
          </div>
          <vue-range-slider ref="slider" width="100%" v-model="area"
            @input="filterdTable(price, rooms, area, isAvailable, checkedTypes)" :min="minArea" :max="maxArea"
            :step="5">
          </vue-range-slider>
        </div>

        <div class="col-md-12 col-lg-2">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">
            <label class="btn btn-outline-dark twoqbsStageButton">
              <input type="checkbox" v-model="isAvailable"
                @change="filterdTable(price, rooms, area, isAvailable, checkedTypes)" />
              Tylko dostępne
            </label>

          </div>
        </div>

       
        <div class="col-md-12 col-lg-2">
          <div class="mb-5 mt-2" style="text-align: center; padding-bottom: 2.5rem">
            <!-- <button class="btn btn-outline-dark" @click="showModal(selectedFlats)">Zapytaj o ofertę
              <span v-if="selectedFlats.length > 0">({{ selectedFlats.length }})</span>
            </button> -->
            <a href="/prospekty" target="_blank" rel="noopener" class="btn btn-outline-dark">
              Prospekt informacyjny
            </a>
          </div>
        </div>
  

      </div>

      <div class="row" style="max-width: 98%">

        <table class="
            twoqbsxml-table
            table
            d-none d-md-table d-lg-table
            mx-4
            my-4
          ">

          <thead class="twoqbsxml-thead">
            <th scope="col" class="twoqbsxml-th">Numer lokalu</th>
            <th scope="col" class="twoqbsxml-th ">Rodzaj lokalu</th>
            <th scope="col" class="twoqbsxml-th" @click="sortBy('area')" style="cursor: pointer">Powierzchnia
              <br>(użytkowa)<span v-if="sortKey === 'area'">
                <span v-if="sortAsc">↑</span>
                <span v-else>↓</span>
              </span>
            </th>
            <th scope="col" class="twoqbsxml-th" @click="sortBy('rooms')" style="cursor: pointer">Liczba pokoi<span
                v-if="sortKey === 'rooms'">
                <span v-if="sortAsc">↑</span>
                <span v-else>↓</span>
              </span></th>
            <th scope="col" class="twoqbsxml-th">Cena za<span>m<sup>2</sup></span>brutto <br>(pow. użytkowa)</th>
            <th scope="col" class="twoqbsxml-th">Piętro</th>
            <th scope="col" class="twoqbsxml-th" @click="sortBy('price')" style="cursor: pointer">Cena brutto
           <span
                v-if="sortKey === 'price'">
                <span v-if="sortAsc">↑</span>
                <span v-else>↓</span>
              </span></th>
            <th scope="col" class="twoqbsxml-th">Status</th>
            <th colspan="5" class="twoqbsxml-th"></th>


          </thead>
          <tbody>
            <tr v-if="sortedFlats.length === 0">
              <td colspan="12"><span style="color:red;">{{ sortedFlats.length === 0 ? 'Brak lokali spełniających kryteria' : '' }}</span></td>
            </tr>
            <template v-for="item in sortedFlats" >
              <!-- wiersz główny -->
              <tr class="twoqbsxml-tr" :key="item.id" :id="item.local_number">

                <!-- <tr class="twoqbsxml-tr" v-for="item in sortedFlats" :key="item.id" :id="item.local_number"> -->
                <td class="twoqbsxml-td twoqbsxml-local-name">
                  {{ item.local_number }}
  <div v-if="item.stage && item.stage !== '' && !Array.isArray(item.stage)" 
       style="font-size: 0.75em; color: #999; margin-top: 2px; font-style: italic;">
    {{ item.stage }}
  </div>
                </td>
                <td class="twoqbsxml-td twoqbsxml-scrolling-cell">
                  <div class="scrolling-text">{{ item.type }}</div>
                </td>
                <td class="twoqbsxml-td">
                  <span v-if="(item.area && item.area > 0) || (item.area_usable && item.area_usable > 0)">
                    {{ item.area && item.area > 0 ? item.area : item.area_usable }}m<sup>2</sup>
                  </span>
                  <span v-else>-</span>
                  <tooltip-modal v-if=hasAdditionalAreas(item)>
                    <template #default><contiguity-list-simple :item="item" /></template>
                    <template #icon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 
             1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 
             0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                      </svg></template>
                  </tooltip-modal>
                </td>
                <td class="twoqbsxml-td">
                  <span v-if="item.rooms.length">{{ item.rooms }}
                    <span v-if="item.rooms == 1">pokój</span>
                    <span v-else-if="item.rooms >= 2 && item.rooms <= 4">pokoje</span>
                    <span v-else-if="item.rooms >= 5">pokoi</span></span><span v-else>-</span>
                </td>
                <td class="twoqbsxml-td">

                  <span
                    v-if="item.pricemkw > 0 && item.promotion == 1 && isPromotionActive(item)"
                    style="font-weight:900;">
                    {{ numberWithSpaces(item.promotion_price_mkw) }} zł/m<sup>2</sup><br>
                    <span style="text-decoration: line-through; font-size:13px; font-weight: 300;">
                      {{ numberWithSpaces(item.pricemkw) }} zł/m<sup>2</sup>
                    </span>
                  </span>
                  <span
                    v-else-if="item.pricemkw > 0 && item.promotion == 1 && !isPromotionActive(item)">
                    {{ numberWithSpaces(item.pricemkw) }} zł/m<sup>2</sup>
                  </span>
                  <span v-else-if="item.pricemkw > 0">
                    {{ numberWithSpaces(item.pricemkw) }} zł/m<sup>2</sup>
                  </span>
                  <span v-else>-</span>
                </td>
                <td class="twoqbsxml-td">
                  <span v-if="Number(item.floor) === 0">parter</span>
                  <span v-else>{{ item.floor }} piętro</span>
                </td>
                <td class="twoqbsxml-td">
                  <span
                    v-if="item.promotion == 1 && isPromotionActive(item)"
                    style="font-weight:900;">{{ numberWithSpaces(item.promotion_price) }} zł<br><span
                      style="text-decoration: line-through; font-size:13px; font-weight: 300;">{{
                        numberWithSpaces(item.price) }}
                      zł</span></span>
                  <span
                    v-else-if="item.promotion == 1 && !isPromotionActive(item)">
                    {{ numberWithSpaces(item.price) }} zł
                  </span>
                  <span v-else-if="item.promotion == 0">
                    {{ numberWithSpaces(item.price) }} zł
                  </span>
                     <tooltip-modal>
                <template #default>
                  <span><b>Dom z wykończeniem, cena: 1 424 000 zł</b></span>
                </template>
                <template #icon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-info-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                  </svg>
                </template>
              </tooltip-modal>
                  <!-- <span data-toggle="tooltip" data-placement="top" :title="item.name" :data-bs-delay='{"show":0,"hide":0}' data-bs-animation="false">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-info-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path
                        d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                    </svg>
                  </span> -->
                  <!-- {{ Number(item.minimal_price_gross)}} -->
                  <tooltip-modal v-if="Number(item.minimal_price_gross) >= 1">
                    <template #default><span>Ostatnia najniższa cena z 30 dni <br />
                        {{ (numberWithSpaces(item.minimal_price_gross) + ' zł' || '-') }}</span></template>
                    <template #icon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 
             0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                      </svg></template>
                  </tooltip-modal>
                </td>
                <td class="twoqbsxml-td">
                  <!-- <span v-if="item.status_name == 'Dostępne'" style="color:green;">{{
                  item.status_name
                }}</span> -->
                  <span v-if="item.status_name == 'Dostępne' && item.promotion == 0" style="color:green;">{{
                    item.status_name
                  }}</span>
                  <span
                    v-if="item.promotion == 1 && isPromotionActive(item) && item.status_name == 'Dostępne'"
                    style="font-weight:900; color:green">Promocja</span>
                  <span
                    v-if="item.promotion == 1 && !isPromotionActive(item) && item.status_name == 'Dostępne'"
                    style="color:green">Dostępne</span>
                  <span v-if="
                    item.status_name == 'Rezerwacja ustna' ||
                    item.status_name == 'Umowa rezerwacyjna'
                  " style="color: orange">Rezerwacja</span>

                  <span v-if="
                    item.status_name == 'Umowa końcowa' ||
                    item.status_name == 'Umowa deweloperska' ||
                    item.status_name == 'Umowa przedwstępna'
                  " style="color: red">Sprzedany</span>
                </td>
                <!-- <td class="twoqbsxml-td">{{ item.stage }}</td> -->
                <td class="twoqbsxml-td twoqbsxml-download-element twoqbsxml-document-link">
                  <!-- <a v-if="item.document_link" style="text-decoration: none; color: black"
                    v-bind:href="item.document_link" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                      height="16" fill="currentColor" class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
                      <path
                        d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                      <path
                        d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                    </svg></a> -->
                  <tooltip-modal v-if="item.document_link">
                    <template #default>
                      <span>Zobacz Rzut</span>
                    </template>
                    <template #icon>
                      <a :href="item.document_link" target="_blank" style="text-decoration: none; color: black">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
                          class="bi bi-file-earmark-arrow-down mx-1" viewBox="0 0 16 16">
                          <path
                            d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                          <path
                            d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                        </svg>
                      </a>
                    </template>
                  </tooltip-modal>
                    <!-- Rzut 3D parter - wyświetl zawsze gdy jest element -->
                  <tooltip-modal v-if="item.plan3d_link && (typeof item.plan3d_link === 'string' || (Array.isArray(item.plan3d_link) && item.plan3d_link.length > 0))">
                    <template #default>
                      <span>Zobacz Rzut 3D parter</span>
                    </template>
                    <template #icon>
                      <a :href="typeof item.plan3d_link === 'string' ? item.plan3d_link : (Array.isArray(item.plan3d_link) && item.plan3d_link.length === 1 ? item.plan3d_link[0] : item.plan3d_link[1])" target="_blank" style="text-decoration: none; color: black">
                       <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-badge-3d mx-1" viewBox="0 0 16 16">
  <path d="M4.52 8.368h.664c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914zm3.606-3.367V11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984zm1.187.967h.844c1.112 0 1.621.686 1.621 2.04 0 1.353-.505 2.02-1.621 2.02h-.844z"/>
  <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>
</svg>
                      </a>

                    </template>
                  </tooltip-modal>
                  <!-- Rzut 3D piętro - wyświetl tylko gdy są 2 elementy -->
                  <tooltip-modal v-if="Array.isArray(item.plan3d_link) && item.plan3d_link.length === 2">
                    <template #default>
                      <span>Zobacz Rzut 3D piętro</span>
                    </template>
                    <template #icon>
                      <a :href="item.plan3d_link[0]" target="_blank" style="text-decoration: none; color: black">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-badge-3d mx-1" viewBox="0 0 16 16">
  <path d="M4.52 8.368h.664c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914zm3.606-3.367V11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984zm1.187.967h.844c1.112 0 1.621.686 1.621 2.04 0 1.353-.505 2.02-1.621 2.02h-.844z"/>
  <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>
</svg>
                      </a>
                    </template>
                  </tooltip-modal>
                </td>
                <td class="twoqbsxml-td twoqbsxml-download-element twoqbsxml-virtual-walk">
                  <!-- <a v-if="item.virtual_walk.length > 0" style="text-decoration: none; color: black"
                    v-bind:href="item.virtual_walk" target="_blank" title="Wirtualny spacer"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                      height="16" fill="currentColor" class="bi bi-dpad" viewBox="0 0 16 16">
                      <path
                        " />
                      <path
                        d="M6.5 0A1.5 1.5 0 0 0 5 1.5v3a.5.5 0 0 1-.5.5h-3A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 6.5 16h3a1.5 1.5 0 0 0 1.5-1.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 16 9.5v-3A1.5 1.5 0 0 0 14.5 5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 9.5 0zM6 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 11.5 6h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a1.5 1.5 0 0 0-1.5 1.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 4.5 10h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 6 4.5z" />
                    </svg></a> -->
                  <tooltip-modal v-if="item.virtual_walk.length > 0">
                    <template #default>
                      <span>Wirtualny spacer</span>
                    </template>
                    <template #icon>
                      <a :href="item.virtual_walk" target="_blank" style="text-decoration: none; color: black">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
                          class="bi bi-dpad mx-1" viewBox="0 0 16 16">
                          <path
                            d="m7.788 2.34-.799 1.278A.25.25 0 0 0 7.201 4h1.598a.25.25 0 0 0 .212-.382l-.799-1.279a.25.25 0 0 0-.424 0Zm0 11.32-.799-1.277A.25.25 0 0 1 7.201 12h1.598a.25.25 0 0 1 .212.383l-.799 1.278a.25.25 0 0 1-.424 0ZM3.617 9.01 2.34 8.213a.25.25 0 0 1 0-.424l1.278-.799A.25.25 0 0 1 4 7.201V8.8a.25.25 0 0 1-.383.212Zm10.043-.798-1.277.799A.25.25 0 0 1 12 8.799V7.2a.25.25 0 0 1 .383-.212l1.278.799a.25.25 0 0 1 0 .424Z" />
                          <path
                            d="M6.5 0A1.5 1.5 0 0 0 5 1.5v3a.5.5 0 0 1-.5.5h-3A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 6.5 16h3a1.5 1.5 0 0 0 1.5-1.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 16 9.5v-3A1.5 1.5 0 0 0 14.5 5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 9.5 0zM6 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 11.5 6h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a1.5 1.5 0 0 0-1.5 1.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 4.5 10h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 6 4.5z" />
                        </svg>
                      </a>
                    </template>
                  </tooltip-modal>
                </td>
                <td class="twoqbsxml-td twoqbsxml-download-element twoqbsxml-view360">
                  <tooltip-modal v-if="item.view360.length > 0" style="margin-left: 10px;">
                    <template #default>
                      <span>Widok 360°</span>
                    </template>
                    <template #icon>
                      <a :href="item.view360" target="_blank" style="text-decoration: none; color: black;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
                          class="bi bi-globe mx-1" viewBox="0 0 16 16">
                          <path
                            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" />
                        </svg>
                      </a>
                    </template>
                  </tooltip-modal>
                </td>
                <td class="twoqbsxml-td">
                  <!-- ZAMIEŃ checkbox na przycisk w tabeli DESKTOP (linia ~304) -->
                  <button class="btn btn-outline-dark" @click="showModal(item.local_number)">
                    Zapytaj
                  </button>
                </td>
                 <td class="twoqbsxml-td">
                  <button class="btn btn-outline-dark" @click="toggleRow(item.id)">
                    {{ expandedRows.includes(item.id) ? "Zwiń" : "Zobacz więcej" }}
                  </button>
                </td>
                <!-- <td class="twoqbsxml-td"> -->
                  <!-- <a v-if="investmentInfo.informative_prospectus_link1" class="btn btn-outline-dark"
                    :href="investmentInfo.informative_prospectus_link1" target="_blank" rel="noopener" download>
                    Prospekt informacyjny
                  </a>
                  <span v-else class="btn btn-outline-dark disabled">Prospekt informacyjny</span> -->
                  <!-- <a v-if="getProspectLink(item.stage)" class="btn btn-outline-dark" :href="getProspectLink(item.stage)"
                    target="_blank" rel="noopener" download>
                    Prospekt informacyjny
                  </a> -->
                  <!-- <span v-else class="btn btn-outline-dark disabled">Prospekt informacyjny</span> -->
                <!-- </td> -->
              </tr>
              <tr v-if="expandedRows.includes(item.id)" :key="item.id">

                <td colspan="14" class="twoqbsxml-td expanded-row">
                  <div class="row">
                    <div class="col-6">
                      <contiguity-list :item="item" />
                 <div class="twoqbsxml-expanded-additional-field mt-4" v-if="pluginSettings.additional_field">

                        <h5>Dodatkowe informacje:</h5>
                         <div v-html="pluginSettings.additional_field"></div>
                        <!-- <p>{{ pluginSettings.additional_field }}</p> -->
                            </div> 
                      </div>
                    <div class="col-6">
                      <!-- <p><b>Etap:</b> {{ item.stage }}</p> -->
                      <!-- <p><b>Powierzchnia do wyłacznego uzytku:</b>{{ item.contiguity_list }}</p> -->
                      <p>{{ }}</p>
                      <price-history :flat-id="item.id" />
                     
                 
                      <div class="twoqbsxml-expanded-additional-field mt-4" v-if="item.monetary_benefits">
                        <h5>Inne świadczenia pieniężne: {{ item.monetary_benefits }}</h5>
                          <div v-html="item.monetary_benefits"></div>
</div>
                    </div>
                  </div>
                </td>

              </tr>
            </template>
            <!-- <td class="twoqbsxml-td twoqbsxml-ask">
                <span class="ask-button" @click="showModal(item)" v-if="item.ask_for_price == 1"> Zapytaj</span> -->
            <!-- <span @click="showModal(item)"
                  v-if="item.price && item.ask_for_price != 1 && item.promotion == 0 && (item.status_name != 'Wstrzymane' && item.status_name != 'Rezerwacja ustna') && item.local_number != '2.ZB2.B1' && item.local_number != '2.ZB6.B2'">{{
                    numberWithSpaces(item.price) }} zł</span>
                <span @click="showModal(item)"
                  v-if="item.price && item.ask_for_price != 1 && item.promotion == 1 && !(item.promotion_date_to > today && item.promotion_date_from <= today) && (item.status_name != 'Wstrzymane' && item.status_name != 'Rezerwacja ustna') && item.local_number != '2.ZB2.B1' && item.local_number != '2.ZB6.B2'">{{
                    numberWithSpaces(item.price) }} zł</span>
                <span @click="showModal(item)"
                  v-else-if="item.price && item.ask_for_price != 1 && (item.status_name != 'Wstrzymane' && item.status_name != 'Rezerwacja ustna') && (item.local_number == '2.ZB2.B1' || item.local_number == '2.ZB6.B2')">
                  {{ numberWithSpaces(item.promotion_price) }} zł</span> -->
            <!-- <span @click="showModal(item)" v-if="item.price && item.ask_for_price != 1 && item.promotion == 0 && (item.status_name!='Wstrzymane' && item.status_name != 'Rezerwacja ustna')" >{{ numberWithSpaces(item.price) }} zł</span> -->
            <!-- <span class="td-promotion-price" @click="showModal(item)"
                  v-else-if="item.price >= 1 && item.ask_for_price != 1 && item.promotion == 1 && (item.promotion_date_to > today && item.promotion_date_from <= today)">{{
                    numberWithSpaces(item.promotion_price) }} zł</span>
                <span
                  v-if="(!item.price || item.status_name == 'Wstrzymane' || item.status_name == 'Rezerwacja ustna') && item.ask_for_price != 1">-</span>
                <span v-if="(
                  item.status_name == 'Umowa rezerwacyjna' ||
                  item.status_name == 'Umowa deweloperska' ||
                  item.status_name == 'Umowa przedwstępna' ||
                  item.status_name == 'Wstrzymane' ||
                  item.status_name == 'Rezerwacja ustna')"></span>
              </td>
              <td class="twoqbsxml-td twoqbsxml-download-element"
                v-if="item.price && item.ask_for_price != 1 && (item.status_name != 'Wstrzymane' && item.status_name != 'Rezerwacja ustna')">
                <button class="btn btn-sm ZapytajButton" type="button" onclick="location.href='#kontakt'">Zapytaj o
                  rabat</button></td> -->
            <!-- <td   class="twoqbsxml-td twoqbsxml-download-element"  v-if="item.price && item.ask_for_price != 1 && (item.status_name!='Wstrzymane' && item.status_name != 'Rezerwacja ustna') && (item.local_number == '2.ZB2.B1' || item.local_number == '2.ZB6.B2') "><button class="btn btn-sm PromocjaButton" type="button" onclick="location.href='#kontakt'">PROMOCJA</button></td>
          -->
            <!-- <td v-else></td> -->


          </tbody>
        </table>
      </div>
    </div>
    <!--koniec wersji desktopowej-->
    <!-- Wersja mobilna  -->
    <div class="d-block d-sm-block d-md-none my-3">
      <div class="d-block d-md-none mx-auto">
        <button class="btn btn-outline-dark w-100 mb-3" @click="showMobileFilters = true">
          <span v-if="sortedFlats.length === 0" style="color:red;">Brak lokali spełniających kryteria</span>
          <span v-else>Pokaż filtry </span>
        </button>
        <div v-if="showMobileFilters" class="mobile-filters-overlay">
          <div class="mobile-filters-panel">
            <button class="btn-close" @click="showMobileFilters = false">×</button>
            <div class="mb-3">
              <b>Rodzaj lokalu</b>
              <div class="twoqbsTypeCheckboxList text-start text-nowrap">
                <div v-for="(item, index) in typeOf" :key="index">
                  <input @change="filterdTable(price, rooms, area, isAvailable, checkedTypes)" type="checkbox"
                    :id="'mobile-' + item" v-model="checkedTypes" :value="item" />
                  <label :for="'mobile-' + item">
                    <span>&nbsp;</span>{{ item }}
                  </label>
                </div>
              </div>
            </div>
            <div class="mb-3 text-start mt-5">

              <vue-range-slider width="100%" v-model="price"
                @input="filterdTable(price, rooms, area, isAvailable, checkedTypes)" :min="minPrice" :max="maxPrice"
                :step="10000">
              </vue-range-slider> <b class="text-start">Cena</b>
            </div>
            <div class="mb-3 text-start">

              <vue-range-slider width="100%" v-model="rooms"
                @input="filterdTable(price, rooms, area, isAvailable, checkedTypes)" :min="minRooms" :max="maxRooms"
                :step="1">
              </vue-range-slider><b>Pokoje</b>
            </div>
            <div class="mb-3 text-start">

              <vue-range-slider width="100%" v-model="area"
                @input="filterdTable(price, rooms, area, isAvailable, checkedTypes)" :min="minArea" :max="maxArea"
                :step="5">
              </vue-range-slider> <b>Powierzchnia</b>
            </div>
            <div class="mb-3">
              <label class="btn btn-outline-dark w-100">
                <input type="checkbox" v-model="isAvailable"
                  @change="filterdTable(price, rooms, area, isAvailable, checkedTypes)" />
                Tylko dostępne
              </label>
            </div>

            
            <div class="mb-3">
              <!-- <button class="btn btn-outline-dark" @click="showModal(selectedFlats)">Zapytaj o ofertę
                <span v-if="selectedFlats.length > 0">({{ selectedFlats.length }})</span>
              </button> -->
              <a href="/prospekty" target="_blank" rel="noopener" class="btn btn-outline-dark w-100">
                Prospekt informacyjny
              </a>
            </div>
            

            <button class="btn btn-outline-dark w-100" @click="showMobileFilters = false">
              <span v-if="sortedFlats.length === 0" style="color:red;">Brak lokali spełniających kryteria</span>
              <span v-else>Pokaż wyniki ({{ sortedFlats.length }}) </span>
            </button>
          </div>
        </div>
      </div>


      <div class="d-block d-sm-block d-md-none mx-4 p-2 border" style="text-align: left" v-for="item in sortedFlats"
        :key="item.id">

        <div class="mb-2 d-flex justify-content-between align-items-start">
          <div>
            <b>Numer lokalu:</b> {{ item.local_number }}
  <div v-if="item.stage && item.stage !== '' && !Array.isArray(item.stage)" 
       style="font-size: 0.75em; color: #999; margin-top: 2px; font-style: italic;">
    {{ item.stage }}
  </div></div> <button class="btn btn-outline-dark" @click="showModal([item.local_number])">
            Zapytaj
          </button>
        </div>
        <div>
          <b>Rodzaj:</b> {{ item.type }}
        </div>
        <div>
          <b>Powierzchnia:</b>
          <span v-if="(item.area && item.area > 0) || (item.area_usable && item.area_usable > 0)">
            {{ item.area && item.area > 0 ? item.area : item.area_usable }} m<sup>2</sup>
          </span>
          <span v-else>-</span>
          <tooltip-modal v-if="hasAdditionalAreas(item)">
            <template #default><contiguity-list-simple :item="item" /></template>
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-info-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
              </svg>
            </template>
          </tooltip-modal>
        </div>
        <div>
          <b>Pokoje:</b>
          <span v-if="item.rooms.length">{{ item.rooms }}
            <span v-if="item.rooms == 1">pokój</span>
            <span v-else-if="item.rooms >= 2 && item.rooms <= 4">pokoje</span>
            <span v-else-if="item.rooms >= 5">pokoi</span>
          </span>
          <span v-else>-</span>
        </div>
        <div>
          <b>Cena za m<sup>2</sup>:</b>
          <span
            v-if="item.pricemkw > 0 && item.promotion == 1 && isPromotionActive(item)"
            style="font-weight:900;">
            {{ numberWithSpaces(item.promotion_price_mkw) }} zł/m<sup>2</sup><br>
            <span style="text-decoration: line-through; font-size:13px; font-weight: 300;">
              {{ numberWithSpaces(item.pricemkw) }} zł/m<sup>2</sup>
            </span>
          </span>
          <span
            v-else-if="item.pricemkw > 0 && item.promotion == 1 && !isPromotionActive(item)">
            {{ numberWithSpaces(item.pricemkw) }} zł/m<sup>2</sup>
          </span>
          <span v-else-if="item.pricemkw > 0">
            {{ numberWithSpaces(item.pricemkw) }} zł/m<sup>2</sup>
          </span>
          <span v-else>-</span>
        </div>
        <div>
          <b>Piętro:</b> <span v-if="Number(item.floor) === 0">parter</span>
          <span v-else>{{ item.floor }} piętro</span>
        </div>
        <div>
          <b>Cena brutto:</b>
        
          <span v-if="item.promotion == 1 && isPromotionActive(item)">
            <span style="font-weight:900;">{{ numberWithSpaces(item.promotion_price) }} zł</span>
            <span style="text-decoration: line-through; font-size:13px; font-weight: 300;">
              {{ numberWithSpaces(item.price) }} zł
            </span>

          </span>
          <span v-if="item.promotion == 1 && !isPromotionActive(item)">
            <span>{{ numberWithSpaces(item.price) }} zł</span>
          </span>
          <span v-if="item.promotion == 0">{{ numberWithSpaces(item.price) }} zł</span> <tooltip-modal
            v-if="Number(item.minimal_price_gross) >= 1">
            <template #default><span>Ostatnia najniższa cena z 30 dni <br />
                {{ (numberWithSpaces(item.minimal_price_gross) + ' zł' || '-') }}</span></template>
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-info-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
              </svg></template>
          </tooltip-modal>
            <tooltip-modal>
            <template #default>
              <span>Dom z wykończeniem, cena: 1 424 000 zł</span>
            </template>
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-info-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
              </svg>
            </template>
          </tooltip-modal>
        </div>
        <div>
          <b>Status:</b>
          <span v-if="item.status_name == 'Dostępne' && item.promotion == 0" style="color:green;">{{
            item.status_name
            }}</span>
          <span
            v-if="item.promotion == 1 && isPromotionActive(item) && item.status_name == 'Dostępne'"
            style="font-weight:900; color:green">Promocja</span>
          <span
            v-if="item.promotion == 1 && !isPromotionActive(item) && item.status_name == 'Dostępne'"
            style="color:green">Dostępne</span>
          <span v-if="item.status_name == 'Rezerwacja ustna' || item.status_name == 'Umowa rezerwacyjna'"
            style="color: orange">Rezerwacja</span>
          <span
            v-if="item.status_name == 'Umowa końcowa' || item.status_name == 'Umowa deweloperska' || item.status_name == 'Umowa przedwstępna'"
            style="color: red">Sprzedany</span>
        </div>
        <div class="d-flex gap-2 mb-3 mt-2">
          <!-- Rzut -->
          <a v-if="item.document_link" :href="item.document_link" target="_blank"
             class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1">
            <img src="@/assets/plan.png" width="20" height="20" alt="2D">
            2D
          </a>
          <!-- Rzut 3D parter -->
          <a v-if="item.plan3d_link && (typeof item.plan3d_link === 'string' || (Array.isArray(item.plan3d_link) && item.plan3d_link.length > 0))"
             :href="typeof item.plan3d_link === 'string' ? item.plan3d_link : (Array.isArray(item.plan3d_link) && item.plan3d_link.length === 1 ? item.plan3d_link[0] : item.plan3d_link[1])" 
             target="_blank"
             class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-badge-3d" viewBox="0 0 16 16">
  <path d="M4.52 8.368h.664c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914zm3.606-3.367V11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984zm1.187.967h.844c1.112 0 1.621.686 1.621 2.04 0 1.353-.505 2.02-1.621 2.02h-.844z"/>
  <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>
</svg>
            3D parter
          </a>
          <!-- Rzut 3D piętro - tylko gdy są 2 elementy -->
          <a v-if="Array.isArray(item.plan3d_link) && item.plan3d_link.length === 2"
             :href="item.plan3d_link[0]" 
             target="_blank"
             class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1">
           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-badge-3d" viewBox="0 0 16 16">
  <path d="M4.52 8.368h.664c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914zm3.606-3.367V11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984zm1.187.967h.844c1.112 0 1.621.686 1.621 2.04 0 1.353-.505 2.02-1.621 2.02h-.844z"/>
  <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"/>
</svg>
            3D piętro
          </a>
          <a v-if="item.view360 && item.view360.length > 0" :href="item.view360" target="_blank"
             class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1">
            3D
          </a>
        </div>
        <div class="mt-2">

          <button class="btn btn-outline-dark ms-2" @click="toggleRow(item.id)">
            {{ expandedRows.includes(item.id) ? "Zwiń" : "Zobacz więcej" }}
          </button>
          <!-- <a v-if="getProspectLink(item.stage)" class="btn btn-outline-dark" :href="getProspectLink(item.stage)"
            target="_blank" rel="noopener" download>
            Prospekt informacyjny
          </a>
          <span v-else class="btn btn-outline-dark disabled">Prospekt informacyjny</span> -->
        </div>
        <div v-if="expandedRows.includes(item.id)" class="mt-2">
          <contiguity-list :item="item" />
          <price-history :flat-id="item.id" />
             <div class="mt-4" v-if="item.monetary_benefits">
                        <h5>Inne świadczenia pieniężne: {{ item.monetary_benefits }}</h5>
                          <div v-html="item.monetary_benefits"></div>
</div>
          <div v-if="pluginSettings.additional_field" class=" mt-4">
            <h5>Dodatkowe informacje:</h5>
           <div v-html="pluginSettings.additional_field"></div>
           
          </div>
        </div>
      </div>
    </div>

    <!-- Koniec wersji mobilnej -->
    <contact-form :flat="flat"></contact-form>
  </div>
</template>

<script>
import axios from "axios";
import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";
import ContactForm from "./components/ContactForm";
import TooltipModal from "./components/TooltipModal.vue";
import PriceHistory from "./components/PriceHistory.vue";
import ContiguityList from "./components/ContiguityList.vue";
import ContiguityListSimple from "./components/ContiguityListSimple.vue";

export default {
  name: "App",
  data() {
    return {
      url: window.location.origin,
      // url: "https://osiedleroztocze.pl",-> do testów lokalnych
      dataUrl: this.url + "/wp-json/twoqbs/v1/flats?nocache=1",
      singleFlatUrl: this.url + "/wp-json/twoqbs/v1/flat?nocache=1",
      tableFlats: [],
      flats: [],
      investmentInfo: [],
      pluginSettings: [],
      mainColor: "#63b0bd",
      //--Filtrowanie.
      minPrice: 0,
      maxPrice: 0,
      price: [this.minPrice, this.maxPrice],
      minArea: 0,
      maxArea: 0,
      area: [this.minArea, this.maxArea],
      minRooms: 0,
      maxRooms: 0,
      rooms: [this.minRooms, this.maxRooms],
      isAvailable: false,
      flat: {},
      showTypeFilters: false,
      currentSort: 'name',
      currentSortDir: 'asc',
      checkedTypes: [],
      typeOf: [],
      today: new Date().toISOString().split('T')[0],
      sortKey: '',       // aktualna kolumna sortowania
      sortAsc: true,     // kierunek sortowania: true = rosnąco
      expandedRows: [],  // rozwijana wiersz
      selectedFlats: [], // tu będą ID zaznaczonych mieszkań
      showMobileFilters: false,

    };
  },
  components: {
    VueRangeSlider,
    "contact-form": ContactForm,
    "tooltip-modal": TooltipModal,
    "price-history": PriceHistory,
    "contiguity-list": ContiguityList,
    "contiguity-list-simple": ContiguityListSimple
  },
  methods: {

    toggleRow(id) {
      if (this.expandedRows.includes(id)) {
        this.expandedRows = this.expandedRows.filter(rowId => rowId !== id);
      } else {
        this.expandedRows.push(id);
      }
    },

    sortBy(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc; // zmiana kierunku
      } else {
        this.sortKey = key;
        this.sortAsc = true; // domyślnie rosnąco
      }
    },
    isPromotionActive(item) {
      console.log('Promocja:', item.promotion, 'DateFrom:', item.promotion_date_from, 'DateTo:', item.promotion_date_to);
      
      // Warunek 1: Flaga promocji musi być włączona
      if (item.promotion != 1) {
        console.log('Promocja wyłączona');
        return false;
      }
      
      // Warunek 2: Muszą istnieć ceny promocyjne (większe od 0)
      const hasPromotionPrice = item.promotion_price && Number(item.promotion_price) > 0;
      const hasPromotionPriceMkw = item.promotion_price_mkw && Number(item.promotion_price_mkw) > 0;
      
      if (!hasPromotionPrice || !hasPromotionPriceMkw) {
        console.log('Brak cen promocyjnych - promocja nieaktywna');
        return false;
      }
      
      const today = this.today;
      const dateFrom = item.promotion_date_from;
      const dateTo = item.promotion_date_to;
      
      // Pomocnicza funkcja - sprawdza czy wartość jest pusta
      const isEmpty = (val) => {
        return !val || val === '' || (Array.isArray(val) && val.length === 0);
      };
      
      // Scenariusz 1: Promocja bez dat - zawsze aktywna
      if (isEmpty(dateFrom) && isEmpty(dateTo)) {
        console.log('SCENARIUSZ 1: Promocja bezterminowa - AKTYWNA');
        return true;
      }
      
      // Scenariusz 2: Tylko data "do" (bez daty "od") - aktywna do daty "do"
      if (isEmpty(dateFrom) && !isEmpty(dateTo)) {
        return today <= dateTo;
      }
      
      // Scenariusz 3: Tylko data "od" (bez daty "do") - aktywna od daty "od" w nieskończoność
      if (!isEmpty(dateFrom) && isEmpty(dateTo)) {
        return dateFrom <= today;
      }
      
      // Scenariusz 4: Obie daty ustawione - klasyczny przedział
      if (!isEmpty(dateFrom) && !isEmpty(dateTo)) {
        return dateFrom <= today && today <= dateTo;
      }
      
      // Fallback - jeśli coś poszło nie tak
      return false;
    },

    numberWithSpaces(price) {
      if (price === null || price === undefined || price === "") return "";
      // Zamień na liczbę, zaokrąglij do 2 miejsc po przecinku jeśli jest float
      const num = Number(price);
      if (isNaN(num)) return price;
      // Jeśli liczba jest całkowita
      if (Number.isInteger(num)) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      // Jeśli liczba jest zmiennoprzecinkowa
      const parts = num.toFixed(2).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(",");
    },
    test() {
      console.log(this.isAvailable);
    },

    compare(a, b) {
      // Priorytet 1: Typ lokalu - "Mieszkanie" na początku
      const isAFlat = a.type === "Mieszkanie";
      const isBFlat = b.type === "Mieszkanie";
      
      if (isAFlat && !isBFlat) return -1;  // a jest mieszkaniem, b nie - a pierwsze
      if (!isAFlat && isBFlat) return 1;   // b jest mieszkaniem, a nie - b pierwsze
      
      // Priorytet 2: Jeśli oba są tego samego typu (lub obie nie-mieszkania), sortuj po id
      if (a.id < b.id) return -1;
      if (a.id > b.id) return 1;
      
      return 0;
    },

    filterdTable(price, rooms, area, available, checkedTypes) {
      this.tableFlats = [];
      this.flats.realestate.forEach((item) => {
        // POPRAWIONA LOGIKA CENY - używa nowej funkcji
        const itemPrice = this.isPromotionActive(item)
          ? item.promotion_price
          : item.price;
        
        const itemArea = (item.area && Number(item.area) > 0) ? Number(item.area) : Number(item.area_usable);
        // warunki wspólne
        const inRooms = item.rooms >= rooms[0] && item.rooms <= rooms[1];
        const inArea = itemArea >= area[0] && itemArea <= area[1];
        const inPrice = itemPrice >= price[0] && itemPrice <= price[1];
        const inStage = checkedTypes.length !== 0 ? checkedTypes.includes(item.type) : true;

        if (available) {
          if (
            inRooms &&
            inArea &&
            inPrice &&
            item.status_name === "Dostępne" &&
            inStage
          ) {
            if (item.dont_send_to_www == 0) {
              console.log(this.item)
              this.tableFlats.push(item);
            }
          }
        } else {
          if (
            inRooms &&
            inArea &&
            inPrice &&
            inStage
          ) {
            if (item.dont_send_to_www == 0 && item.status_id != 9) {
              this.tableFlats.push(item);
            }
          }
        }
      });

      // sortowanie na końcu (raz, a nie w każdej iteracji)
      this.tableFlats.sort(this.compare);
      this.updateVisibleStages(); // DODAJ TĘ LINIĘ
    }
    ,
    showModal(flatName) { this.$modal.show('contact-form', { flat: flatName });
    document.body.style.overflow = 'hidden';
      this.flat = flatName;
    },
    getTypesOf(flats) {
  flats.forEach((item) => {
    if (!this.typeOf.includes(item.type)) {
      this.typeOf.push(item.type)
    }
  })
  this.typeOf.sort((a, b) => a.localeCompare(b));
  // Przesuń "Mieszkanie" na początek, jeśli istnieje
  const idx = this.typeOf.indexOf("Mieszkanie");
  if (idx > 0) {
    this.typeOf.splice(idx, 1);
    this.typeOf.unshift("Mieszkanie");
  }
  return this.typeOf
},

    getPriceRange(flats) {
      this.price = []; // reset tablicy

      flats.forEach((item) => {
        // Użyj tej samej logiki co w filterdTable - sprawdź czy promocja aktywna
        let priceToUse = item.price;
        
        // Sprawdź czy promocja jest aktywna (uproszczona wersja bez dat - dla zakresu)
        if (item.promotion == 1 && item.promotion_price && Number(item.promotion_price) > 0 && 
            item.promotion_price_mkw && Number(item.promotion_price_mkw) > 0) {
          priceToUse = item.promotion_price;
        }
        
        const value = parseInt(priceToUse);
        if (!isNaN(value) && value > 0) {
          this.price.push(value);
        }
      });
      
      const cenyBezZera = this.price.filter(v => v > 0);
      if (cenyBezZera.length > 0) {
        const min = Math.min(...cenyBezZera);
        const max = Math.max(...cenyBezZera);
        this.minPrice = Math.floor(min / 10000) * 10000; // zaokrąglamy w dół
        console.log(this.minPrice)
        this.maxPrice = Math.ceil(max / 10000) * 10000;  // zaokrąglamy w górę
        this.price = [];
        this.price.push(this.minPrice);
        this.price.push(this.maxPrice)
      } else {
        this.minPrice = 0;
        this.maxPrice = 10000000;
        this.price = [];
        this.price.push(this.minPrice);
        this.price.push(this.maxPrice)
      }
    },
    getRoomsRange(flats) {
      this.rooms = []; // reset tablicy

      flats.forEach((item) => {
        const value = parseInt(item.rooms);

        if (!isNaN(value) && value > 0) {
          // tylko poprawne liczby > 0
          this.rooms.push(value);
        } else {
          // console.log("rooms pominąłem:", item.rooms);
        }
      });

      if (this.rooms.length > 0) {
        this.minRooms = Math.min(...this.rooms);
        this.maxRooms = Math.max(...this.rooms);
        this.minRooms = 0;
        this.rooms = []
        this.rooms.push(this.minRooms)
        this.rooms.push(this.maxRooms)
      } else {
        this.minRooms = 0;
        this.maxRooms = 10;
        this.rooms = []
        this.rooms.push(this.minRooms)
        this.rooms.push(this.maxRooms)
      }
    },
    getAreaRange(flats) {
      this.area = []; // reset tablicy

      flats.forEach((item) => {
        const value = parseInt(item.area);

        if (!isNaN(value) && value > 0) {
          // tylko poprawne liczby > 0
          this.area.push(value);
        } else {
          // console.log("area usable pominąłem:", item.area_usable);
        }
      });

      if (this.area.length > 0) {
        const min = Math.min(...this.area);
        const max = Math.max(...this.area);
        this.minArea = Math.floor(min / 10) * 10; // zaokrąglamy w dół
        this.maxArea = Math.ceil(max / 10) * 10;  // zaokrąglamy w górę
        this.area = [];
        this.area.push(this.minArea)
        this.area.push(this.maxArea)
      } else {
        this.minArea = 0;
        this.maxArea = 500;
        this.area = [];
        this.area.push(this.minArea)
        this.area.push(this.maxArea)
      }
    },
    hasAdditionalAreas(item) {
      return (
      (item.balkon && String(item.balkon).trim() !== "" && item.balkon !== "0") ||
      (item.taras && String(item.taras).trim() !== "" && item.taras !== "0") ||
      (item.loggia && String(item.loggia).trim() !== "" && item.loggia !== "0") ||
      (item.ogrod && String(item.ogrod).trim() !== "" && item.ogrod !== "0") ||
      (item.contiguity_list?.contiguity?.length > 0)
      );
    },

    getProspectLink(stage) {
      if (!this.pluginSettings) return null;
      let key;
      if (!stage || !String(stage).trim()) {
        key = 'prospect_brak-etapu';
      } else {
        key = 'prospect_' + this.sanitizeTitle(stage);
      }
      return this.pluginSettings[key] || null;
    },
    sanitizeTitle(str) {
      return String(str)
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-_]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
    },
    updateVisibleStages() {
      const stages = [...new Set(this.tableFlats.map(item => item.stage).filter(Boolean))];
      localStorage.setItem('visible_stages', JSON.stringify(stages));
      console.log('Visible stages saved to localStorage:', stages);
    }

  },

  computed: {
    sortedFlats() {
      const sorted = [...this.tableFlats];
      if (this.sortKey === 'price') {
        sorted.sort((a, b) => {
          // POPRAWIONA LOGIKA - używa nowej funkcji
          const aPrice = this.isPromotionActive(a) ? a.promotion_price : a.price;
          const bPrice = this.isPromotionActive(b) ? b.promotion_price : b.price;
          return this.sortAsc ? aPrice - bPrice : bPrice - aPrice;
        });
      } else if (this.sortKey === 'rooms') {
        sorted.sort((a, b) => {
          return this.sortAsc
            ? Number(a.rooms) - Number(b.rooms)
            : Number(b.rooms) - Number(a.rooms);
        });
      } else if (this.sortKey === 'area') {
        sorted.sort((a, b) => {
          const areaA = a.area_usable && a.area_usable > 0 ? Number(a.area_usable) : Number(a.area);
          const areaB = b.area_usable && b.area_usable > 0 ? Number(b.area_usable) : Number(b.area);
          return this.sortAsc
            ? areaA - areaB
            : areaB - areaA;
        });
      }

      return sorted;
    },





  },

  watch: {
    showMobileFilters(val) {
      const html = document.documentElement;
      if (val) {
        document.body.classList.add('no-scroll');
        document.body.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';
        html.style.overflow = 'hidden';
      } else {
        document.body.classList.remove('no-scroll');
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
        html.style.overflow = '';
      }
    }
  },


  mounted() {
    // const autoUrl = window.location.origin + "/wp-json/twoqbs/v1/flats?nocache=" + new Date().getTime()
    // const autoUrlSettings = window.location.origin + "/wp-json/twoqbs/v1/settings?nocache=" + new Date().getTime()
    // const autoUrlInvestment = window.location.origin + "/wp-json/twoqbs/v1/investment?nocache=" + new Date().getTime()

    const autoUrl = "https://przystanekplochocin.pl/wp-json/twoqbs/v1/flats?nocache=" + new Date().getTime()  //-> do testów lokalnych
    const autoUrlSettings = "https://przystanekplochocin.pl/wp-json/twoqbs/v1/settings?nocache=" + new Date().getTime() // -> do testów lokalnych
    const autoUrlInvestment = "https://przystanekplochocin.pl/wp-json/twoqbs/v1/investment?nocache=" + new Date().getTime() // -> do testów lokalnych

    // const autoUrl = "https://test.2qbs.pl/wp-json/twoqbs/v1/flats?nocache=" + new Date().getTime()  //-> do testów lokalnych
    // const autoUrlSettings = "https://test.2qbs.pl/wp-json/twoqbs/v1/settings?nocache=" + new Date().getTime() // -> do testów lokalnych
    // const autoUrlInvestment = "https://test.2qbs.pl/wp-json/twoqbs/v1/investment?nocache=" + new Date().getTime() // -> do testów lokalnych
    axios.get(autoUrl).then((response) => {
      this.flats = response.data;
      this.tableFlats = this.flats.realestate;
      // console.log(this.tableFlats)
      this.tableFlats.sort(this.compare);
      this.getTypesOf(this.tableFlats)
      this.getPriceRange(this.tableFlats)
      this.getRoomsRange(this.tableFlats)
      this.getAreaRange(this.tableFlats)
      this.filterdTable(this.price, this.rooms, this.area, this.available, this.checkedTypes)

    });

    axios.get(autoUrlSettings).then((response) => {
      this.pluginSettings = response.data;
      this.mainColor = this.pluginSettings.main_color || '#63b0bd';
      this.setSliderBackground();
      // console.log(this.pluginSettings)
    });

    axios.get(autoUrlInvestment).then((response) => {
      this.investmentInfo = response.data;
      // console.log(this.investment)
    });

    axios.post(this.restUrl, this.contactForm).then((response) => {
      console.log(response);

    });

      this.$modal.$on('hidden', () => {
    document.body.style.overflow = '';
  });


  if (this.$modal && this.$modal.$on) {
    this.$modal.$on('opened', (modalName) => {
      if (modalName === 'contact-form') {
        document.body.style.overflow = 'hidden';
      }
    });
    this.$modal.$on('closed', (modalName) => {
      if (modalName === 'contact-form') {
        document.body.style.overflow = '';
      }
    });
  }


  },
};
</script>

<style >
#app {
  font-family: "Encode Sans", Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
   margin-top: 60px;
  display: block;

}


.simple-range-slider {
  bottom: -30px;
  background: none;
  box-shadow: none;
}

.modal {
  position: absolute;
  width: 500px;
  height: 500px;
  background-color: red;
}

.toggle-button {
  padding: 8px 12px;
  border: 1px solid #ccc;
  cursor: pointer;
  background: #f8f8f8;
  margin-bottom: 8px;
}

.twoqbsTypeCheckboxList {
  /* border: 1px solid #ddd; */
  padding: 10px;
  max-height: 200px;
  overflow-y: auto;
  background: white;
}





.vue-range-slider.slider-component .slider .slider-process {
  background-color: var(--main-color, #000000);
}

.vue-range-slider.slider-component .slider-tooltip-wrap .slider-tooltip {
  background-color: var(--main-color, #000000);
  border: 1px solid var(--main-color, #000000);
}

.btn-outline-dark {
  --bs-btn-hover-bg: var(--main-color, #000000) !important;
}


/* Styl panelu mobilnych filtrów */
.mobile-filters-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: flex-end;
  overscroll-behavior: contain;
  touch-action: none;
}

.mobile-filters-panel {
  background: #fff;
  width: 90%;
  border-radius: 16px 16px 0 0;
  padding: 24px 16px 16px;
  max-height: 95vh;
  overflow-y: auto;
  position: relative; 
  
  
}

.btn-close {
  position: absolute;
  top:  10px;
  right: 16px;
  background: none;
  border: none;
  font-size: 2rem;
  line-height: 1;
  color: #333;
}

@media (min-width: 768px) {
  .mobile-filters-overlay {
    display: none !important;
  }
}

@import "./assets/vue-range-slider.css";
@import "./assets/bootstrap.min.css";

.vm--modal input,
.vm--modal textarea {
  background-color: #ffffff;
  border-color: #e1e1e1;
  border-width: 0px 0px 1px 0px;
  border-radius: 0px 0px 0px 0px;
}

.vm--modal input,
.vm--modal textarea:focus {
  outline: none;
  border: 1px solid #e1e1e1;
  border-radius: 1px;
}

.vm--modal .form-check-label {
  font-size: 12px;
  text-align: left;
}

.vm--modal {
  height: auto !important;
}

.vm--container {
  overflow: auto;
}

.no-scroll {
  overflow: hidden !important;
  touch-action: none !important;
}
</style>
